import clsx from 'clsx';
import React from 'react';
import {DroppableProvided} from 'react-beautiful-dnd';
import {ReactComponent as DragDropIcon} from '../../../assets/images/icon-drag-drop.svg';
import styles from './DragDropItem.module.scss';

interface Props {
  className?: string;
  children?: React.ReactNode;
  item: React.ReactNode;
  provided: DroppableProvided;
  isDragging: boolean;
}

export default function DragDropItem({className, children, item, isDragging, provided}: Props): React.ReactElement {
  const itemClassName = clsx(
    className,
    styles.item,
    {
      [styles.item_isDragging]: isDragging
    }
  );

  return (
    <div className={itemClassName} ref={provided.innerRef} {...provided.draggableProps}>
      <div className={styles.row}>
        <div className={styles.handle} {...provided.dragHandleProps}>
          <DragDropIcon />
        </div>
        {item}
      </div>
      {children}
    </div>
  );
}
